import { useContext, useState } from "react";
import { AppState } from "App";
import { ThemeContext } from "context/themeContext";
import ThemeToggle from "components/ui/nav/ThemeToggle";
import LanguagesMenu from "components/ui/LanguageMenu";
import AccountButton from "components/ui/nav/AccountButton";
import { AddPostIcon, CalendarIcon, Earth, Heart } from "components/misc/Icons";
import Tooltip from 'components/ui/Tooltip'

const Header = () => {
    const [appState, setAppState] = useContext(AppState);
    const { theme, setTheme } = useContext(ThemeContext);
    const [showTooltip, setShowTooltip] = useState(false)

    return (
        <nav className="flex flex-row items-center justify-between h-16 px-8 border-b bg-itemlight dark:bg-itemdark border-borderlight dark:border-borderdark">
            <div className="flex items-center text-textlight dark:text-textdark">
                <h1 className="mr-8 text-xl font-bold tracking-tight">a logo</h1>
                <div className="relative flex items-center justify-center w-16 h-16 border-l-2 border-r-2 cursor-pointer border-borderlight dark:border-borderdark hover:bg-bglight dark:hover:border-borderdark text-textlight dark:text-textdark dark:hover:bg-hoverdark lg:hidden">
                    <AddPostIcon width="6" height="6" stroke="1" />
                    {appState.tooltips & showTooltip ? <Tooltip message="Add a new post"/> : null}
                </div>
                <div className="flex items-center justify-center w-16 h-16 border-r-2 cursor-pointer border-borderlight dark:border-borderdark hover:bg-bglight dark:hover:border-borderdark text-textlight dark:text-textdark dark:hover:bg-hoverdark lg:hidden">
                    <Heart width="6" height="6" stroke="1" />
                </div>
            </div>
            <div className="flex flex-row">
                <div className="relative flex items-center justify-center w-16 h-16 border-l-2 border-r-2 cursor-pointer border-borderlight dark:border-borderdark hover:bg-bglight dark:hover:border-borderdark text-textlight dark:text-textdark dark:hover:bg-hoverdark yl:hidden">
                    <Earth width="6" height="6" stroke="1" />

                </div>
                <div className="flex items-center justify-center w-16 h-16 cursor-pointer border-borderlight dark:border-borderdark hover:bg-bglight dark:hover:border-borderdark text-textlight dark:text-textdark dark:hover:bg-hoverdark yl:hidden">
                    <CalendarIcon width="6" height="6" stroke="1" />
                </div>
                <div
                    id="seventh"
                    onMouseEnter={() => setShowTooltip(true)}
                    onMouseLeave={() => setShowTooltip(false)}
                    onClick={() =>
                        setTheme(theme === "dark" ? "light" : "dark") |
                        setAppState((prevState) => ({
                            ...prevState,
                            isMapDark: !appState.isMapDark,
                        }))
                    }
                    className="flex items-center justify-center w-16 h-16 border-l-2 cursor-pointer border-borderlight dark:border-borderdark hover:bg-bglight dark:hover:border-borderdark text-textlight dark:text-textdark dark:hover:bg-hoverdark"
                >
                    <ThemeToggle />
                    {appState.tooltips & showTooltip ? <Tooltip message={appState.isMapDark ? 'Change to a light theme' : 'Change to a dark theme'}/> : null}
                </div>
                <div
                    id="eighth"
                    className="flex items-center justify-center w-16 h-16 border-l-2 border-r-2 cursor-pointer border-borderlight dark:border-borderdark hover:bg-bglight dark:hover:border-borderdark text-textlight dark:text-textdark dark:hover:bg-hoverdark"
                >
                    <LanguagesMenu />
                </div>
                <div className="flex items-center justify-center w-16 h-16 border-r-2 border-borderlight dark:border-borderdark">
                    <AccountButton />
                </div>
            </div>
        </nav>
    );
};

export default Header;
